<template>
    <!-- form fields for the auxiliary code -->
    <section>
        <!-- THIRD PARTY ACCOUNT -->
        <el-form-item prop="accountingCodeId" :label="$t.__('common.labels.third_account')">
            <el-select v-model="accounting_code_id" class="wp-10" filterable>
                <el-option
                    v-for="(option, codeKey) in accountingCodeList"
                    :key="codeKey"
                    :value="option.value"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- EXTENSE ACCOUNTING -->
        <el-form-item
            v-if="type === 'supplier'"
            prop="accountingPurchaseCodeId"
            :label="$t.__('thirds.thirdscomponents.FormFieldsAccounting.charges_account')"
        >
            <el-select v-model="accounting_purchase_code_id" class="wp-10" filterable>
                <el-option
                    v-for="(option, purchaseCodeKey) in accountingPurchaseCodeList"
                    :key="purchaseCodeKey"
                    :value="option.value"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- ACCOUNTING (CODE)-->
        <el-form-item
            prop="auxiliaryCode"
            :label="$t.__('thirds.thirdscomponents.FormFieldsAccounting.auxiliary_account_code')"
            v-if="accountingEnabled"
        >
            <el-input autocomplete="off" v-model="auxiliaryCode"></el-input>
        </el-form-item>
    </section>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';

export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
    },
    computed: {
        tagsHuman() {
            return TagHumansConfig;
        },
        type() {
            return this.$store.getters[`${this.currentStore}/getType`];
        },
        accountingEnabled: {
            get() {
                return this.$store.getters[`${this.currentStore}/getAccountingEnabled`];
            },
        },
        accountingCodeList() {
            return this.$store.getters[`${this.currentStore}/getAccountingCodes`];
        },
        accountingPurchaseCodeList() {
            return this.$store.getters[`${this.currentStore}/getAccountingPurchaseCodes`];
        },
        accounting_code_id: {
            get() {
                return this.$store.getters[`${this.currentStore}/getAccountingCodeId`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setAccountingCodeId`, value);
            },
        },
        accounting_purchase_code_id: {
            get() {
                return this.$store.getters[`${this.currentStore}/getAccountingPurchaseCodeId`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setAccountingPurchaseCodeId`, value);
            },
        },
        auxiliaryCode: {
            get() {
                return this.$store.getters[`${this.currentStore}/getAuxiliaryCode`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setAuxiliaryCode`, value);
            },
        },
    },
};
</script>
